import React from 'react';
import styled from 'styled-components';
import {
  minBreakpointQuery,
  maxBreakpointQuery,
  sectionMargins,
} from '../styles';
import { Container, Heading, HtmlContent } from './ui';

const StyledHeadingContent = styled.section`
  ${sectionMargins()};
`;

const StyledInner = styled.div`
  ${minBreakpointQuery.smedium`
    display: grid;
    grid-template-columns: 1fr 1.3fr;
    gap: 30px;
  `}

  ${minBreakpointQuery.medium`
    gap: 40px;
  `}

  ${minBreakpointQuery.mlarge`
    gap: 60px;
  `}

  ${minBreakpointQuery.large`
    gap: 80px;
  `}

  ${minBreakpointQuery.xxlarge`
    gap: 100px;
  `}
`;

const StyledHeading = styled(Heading)`
  ${maxBreakpointQuery.smedium`
    margin-bottom: 20px;
  `}
`;

const HeadingContent = ({ heading, content }) => (
  <StyledHeadingContent>
    <Container>
      <StyledInner>
        <StyledHeading>{heading}</StyledHeading>
        <HtmlContent html={content} />
      </StyledInner>
    </Container>
  </StyledHeadingContent>
);

export default HeadingContent;
